import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FileComponent } from '@enginuity/core/molecules/file/file.component';
import { InputsComponent } from '@enginuity/core/molecules/inputs/inputs.component';

interface BadgePrefix {
  type: string;
  icon: string;
  label: string;
  rightIcon: boolean;
}

@Component({
  selector: 'app-input-wrapper',
  templateUrl: './input-wrapper.component.html',
  styleUrls: ['./input-wrapper.component.scss'],
  imports: [InputsComponent, CommonModule, FileComponent],
})
export class InputWrapperComponent implements OnInit {
  @Output() onChange = new EventEmitter<any>();
  @Input() type: any;
  @Input() conditionLabel: string = '';
  @Input() data: any;
  @Input() prefixConfig: BadgePrefix = {
    type: 'white',
    label: '$',
    rightIcon: false,
    icon: '',
  };

  ngOnInit() {
    console.log(this.onChange);
  }
}
